export const cacheKey = "/app_settings/allowed_territories_for_developer_for_company" as const;
